// Add this attribute with the the role requirements to hide elements
// ggAuthAccess roles="ADMIN,MEMBER" roleCheckType="1"

(function (angular, app) {
   "use strict";

   angular.module(app.modules.member.name)
      .directive(app.modules.member.directives.accesscontrol, AccessControlDirective);
   
   AccessControlDirective.$inject = [
      app.modules.common.constants.rolecheckenum
      , app.modules.common.constants.accesscontrolenum
      , app.modules.member.services.accesscontrol
      , app.modules.common.services.eventbus
   ];
   
   function AccessControlDirective(roleCheckType, accessControlType, ggAccessControlSvc, ggEvents){
      return {
         restrict: 'A'
         , link: function (scope, element, attrs) {
            var makeVisible = function () {
               element.removeClass('hidden');
            },
            makeHidden = function () {
               element.addClass('hidden');
            },
            determineVisibility = function (resetFirst) {
               var result;
               
               result = ggAccessControlSvc.authorize(roles, attrs.roleCheckType);
               if (result === accessControlType.authorized){
                  makeVisible();
               } else {
                  makeHidden();
               }
            },
            roles;
            
            if (attrs.roles){
               roles = attrs.roles.split(',');
               if (roles.length > 0) {
                  determineVisibility(true);
               }   
            }


             // When the status changes, change visibility
            ggEvents.subscribe(app.modules.common.events.authChange, function (event, next) {
                determineVisibility(false);
            });


         }
      };
   }
}(angular, app));